module.exports = __webpack_public_path__ + "static/img/1_1.62a9cb07.jpg";